export default __webpack_public_path__ + "static/media/chad_no_background.1049cf78.png";